module.exports = __webpack_public_path__ + "media/images/app/collections/collection-couture-mobile-2bfce287abf648508f5e78c764baaa2a.webp";